"use client";
import React, { useState } from "react";
import About from "./About";
import Location from "./Location";
import Requirements from "./ApplicationRequirements";

import AdmissionRequirements from "./AdmissionRequirements";
import { Faculty } from "@/types/Faculty";
import ItsItems from "./ItsItems";

interface NavigationMenuProps {
  faculty: Faculty;
  locale: "ar" | "en";
}

const navigationText = {
  ar: ["عن الكليه", "التخصصات", "التواصل", "متطلبات التقديم", "شروط القبول"],
  en: [
    "About the Faculty",
    "Specializations",
    "About University",
    "Admission Requirements",
    "Admission Criteria",
  ],
};

const NavigationMenu: React.FC<NavigationMenuProps> = ({ locale, faculty }) => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const currentText = navigationText[locale];

  return (
    <div className="container">
      <div className="bg-white p-5 rounded-[10px] flex flex-col gap-5">
        <div className="bg-white flex items-center gap-3 justify-center flex-wrap border-b border-b-[#EBEBEB] pb-5 mb-5">
          {currentText.map((item, index) => (
            <p
              key={index}
              className={`cursor-pointer text-center ${
                currentIndex === index + 1
                  ? "text-18 text-white font-[500] bg-primaryColor py-2 px-5 rounded-[10px]"
                  : "text-18 text-darkText font-[500] bg-white py-2 px-5 rounded-[10px]"
              }`}
              onClick={() => setCurrentIndex(index + 1)}
            >
              {item}
            </p>
          ))}
        </div>
        {currentIndex === 1 ? (
          <About item={faculty} />
        ) : currentIndex === 2 ? (
          <ItsItems item={faculty} />
        ) : currentIndex === 3 ? (
          <Location item={faculty} />
        ) : currentIndex === 4 ? (
          <Requirements item={faculty} />
        ) : currentIndex === 5 ? (
          <AdmissionRequirements item={faculty} />
        ) : null}
      </div>
    </div>
  );
};

export default NavigationMenu;

// : currentIndex === 6 ? (
//           <MinimumLimits faculty={faculty} />
//         ) : currentIndex === 7 ? (
//           <Expenses faculty={faculty} />
//         )
